"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUpload = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var deleteFile_svg_1 = __importDefault(require("../../../assets/images/deleteFile.svg"));
var common_1 = require("../../../common");
var UploadIcon_1 = require("./UploadIcon");
var styles = __importStar(require("./FileUpload.module.css"));
var FileUpload = function (_a) {
    var files = _a.files, setFiles = _a.setFiles, color = _a.color, _b = _a.hidden, hidden = _b === void 0 ? false : _b;
    var intl = (0, react_intl_1.useIntl)();
    var _c = (0, react_1.useState)(false), isSizeExceeded = _c[0], setIsSizeExceeded = _c[1];
    var getTotalFileSize = (0, react_1.useCallback)(function () {
        return files.reduce(function (totalSize, file) { return totalSize + file.size; }, 0);
    }, [files]);
    var onUploadFiles = function (files) {
        if (!files)
            return;
        var validFiles = [];
        for (var i = 0; i < files.length; i++) {
            var file = files[i];
            var fileInfo = { name: file.name, size: file.size, file: file };
            validFiles.push(fileInfo);
        }
        var totalSize = getTotalFileSize() + validFiles.reduce(function (totalSize, file) { return totalSize + file.size; }, 0);
        setIsSizeExceeded(totalSize > common_1.MAX_FILES_SIZE_BYTES);
        if (totalSize <= common_1.MAX_FILES_SIZE_BYTES)
            setFiles(function (prevFiles) { return __spreadArray(__spreadArray([], prevFiles, true), validFiles, true); });
    };
    var handleFileRemove = function (nameToRemove) { return setFiles(files.filter(function (_a) {
        var name = _a.name;
        return name !== nameToRemove;
    })); };
    var handleFileDrop = function (e, files) {
        e.preventDefault();
        e.stopPropagation();
        files && onUploadFiles(files);
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ hidden: hidden }, { children: [files.map(function (_a) {
                var name = _a.name;
                return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.fileItem }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: styles.fileName }, { children: name })), (0, jsx_runtime_1.jsx)("button", __assign({ className: styles.removeButton, onClick: function () { return handleFileRemove(name); } }, { children: (0, jsx_runtime_1.jsx)("img", { src: deleteFile_svg_1.default, alt: 'delete', draggable: false }) }))] }), name));
            }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(styles.uploadBox, " ").concat(isSizeExceeded ? styles.sizeExceeded : ''), style: { border: "1px dashed ".concat(color) }, onDrop: function (e) { return handleFileDrop(e, e.dataTransfer.files); }, onDragOver: handleFileDrop }, { children: (0, jsx_runtime_1.jsxs)("label", __assign({ htmlFor: 'file-upload' }, { children: [(0, jsx_runtime_1.jsx)("input", { hidden: true, type: 'file', id: 'file-upload', multiple: true, onChange: function (e) { return onUploadFiles(e.target.files); } }), (0, jsx_runtime_1.jsx)(UploadIcon_1.UploadIcon, { color: color }), (0, jsx_runtime_1.jsx)("span", __assign({ style: { color: color } }, { children: intl.formatMessage({ id: 'selectFiles' }) })), intl.formatMessage({ id: 'orDropFiles' })] })) })), isSizeExceeded && ((0, jsx_runtime_1.jsx)("p", __assign({ className: styles.sizeExceededText }, { children: intl.formatMessage({ id: 'maxFileSizeError' }, { maxSize: common_1.MAX_FILES_SIZE_MEGABYTES }) })))] })));
};
exports.FileUpload = FileUpload;
